import updatePassword from './password/store';

export default {
  namespaced: true,
  modules: { updatePassword },
};
